const configuredApiUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '') || '';

export const API_ORIGIN = configuredApiUrl;
export const API_BASE_URL = `${configuredApiUrl}/api`;
